import Vue from 'vue'
import VueRouter from 'vue-router'

# Views

import Order from '@/views/Order'
import Kiosk from '@/views/Kiosk'
import Start from '@/views/Start'
import Address from '@/views/Address'
import Closed from '@/views/Closed'
import Register from '@/views/Register'
import Menu from '@/views/Menu'
import Checkout from '@/views/Checkout'
import Loading from '@/views/Loading'
import Place from '@/views/Place'
import ThankYou from '@/views/Thankyou'
import Failure from '@/views/Failure'
import MenuDisplay from '@/views/Menudisplay'
import InstantWebsite from '@/views/Website'

Vue.use VueRouter

export default new VueRouter(
  hash: false,
  mode: 'history',
  routes: [
    { path: '/', name: '', component: Order, children: [
        { path: '/Kiosk', name: 'Kiosk', component: Kiosk }
        { path: '/Register', name: 'Register', component: Register }
        { path: '/Address', name: 'Address', component: Address }
        { path: '/Closed', name: 'Closed', component: Closed }
        { path: '/Menu', name: 'Menu', component: Menu }
        { path: '/Checkout', name: 'Checkout', component: Checkout }
        { path: '/Loading', name: 'Loading', component: Loading }
        { path: '/Place', name: 'Place', component: Place }
        { path: '/Thankyou', name: 'ThankYou', component: ThankYou }
        { path: '/Failure', name: 'Failure', component: Failure }
        { path: '/MenuDisplay', name: 'MenuDisplay', component: MenuDisplay }
        { path: '/InstantWebsite', name: 'InstantWebsite', component: InstantWebsite }
        { path: '*', name: 'Start', component: Start }
      ]
    }
  ]
)
